import { Provider } from '@angular/core';
import { ConnectionRepositoryPort } from '../domain/repositories/connection.repository.port';
import { ConnectionRepository } from './repositories/connection.repository';
import { CommunicationRepository } from './repositories/communication.repository';
import { CommunicationRepositoryPort } from '../domain/repositories/communication.repository.port';

export const CONNECTION_PROVIDERS: Provider[] = [
    {
        provide: ConnectionRepositoryPort,
        useClass: ConnectionRepository,
    },
    {
        provide: CommunicationRepositoryPort,
        useClass: CommunicationRepository,
    },
];
